import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Skeleton,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {useRouter, useSearchParams} from "next/navigation";

import SocialMediaLinks from "../../SocialMediaLinks";
import { EventImage } from "../Events/EventAccordion";
import useIsSmallScreen from "../../../utils/useIsSmallScreen";
import Image from "next/image";

const BandCard = ({ data, loading }) => {
  const router = useRouter();
  const isSmallScreen = useIsSmallScreen();
  const handleViewDetails = (e, id, link) => {
    e.stopPropagation();
    router.push(`/bands${link}`, {
      state: { bandId: id },
    });
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {loading ? (
        <Box width={"100%"}>
          <Skeleton height={100} animation="wave" />
          <Skeleton height={100} animation="wave" />
          <Skeleton height={100} animation="wave" />
          <Skeleton height={100} animation="wave" />
          <Skeleton height={100} animation="wave" />
        </Box>
      ) : (
        <Grid container spacing={2}>
          {data.map((band, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Card
                sx={{
                  height: 160,
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                  },
                }}
                onClick={(e) =>
                  handleViewDetails(e, band.id, band.internallink)
                }
              >
                <IconButton
                  aria-label="details"
                  onClick={(e) =>
                    handleViewDetails(e, band.id, band.internallink)
                  }
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    zIndex: 1, // Ensures the button is always clickable
                  }}
                >
                  <VisibilityIcon sx={{ color: "#2a892a" }} />
                </IconButton>
                <CardContent 
                  sx={{ 
                    display: "flex", 
                    alignItems: "center",
                    gap: 2, // ✅ Adds spacing between image and text
                    padding: "8px", // ✅ Ensures padding is not causing issues
                    maxHeight: "120px", // ✅ Prevents content from stretching
                  }}>
                    <Image
                      src={`${band.imageUrl}&width=300&height=300`} // ✅ Resize directly on Firebase
                      alt={band?.bandname || "Band Image"}
                      width={100} 
                      height={100}
                      style={{
                        borderRadius: "8px",
                        objectFit: "cover",
                      }}
                      quality={80} // ✅ Reduce file size
                  />
                  <Box>
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{ fontWeight: "bold" }}
                    >
                      {band?.bandname || "Band Title"}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {band?.alias?.length
                        ? `aka: ${band.alias.join(", ")}`
                        : ""}
                    </Typography>
                  </Box>
                </CardContent>
                {band.socialMediaLinks?.length > 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: -5,
                    }}
                  >
                    <SocialMediaLinks
                      size={"48"}
                      containerSize={30}
                      links={band.socialMediaLinks}
                      onClick={(e) => e.stopPropagation()} // Ensure social media links remain clickable
                    />
                  </Box>
                )}
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default BandCard;
